import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        console.error("App crashed:", error, info);
    }
    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen bg-ink text-paper flex items-center justify-center p-8">
                    <div className="max-w-lg border border-white/15 p-8">
                        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-alert mb-4">
                            System error
                        </p>
                        <h1 className="font-display text-2xl mb-4">Something failed to load</h1>
                        <p className="text-ash text-sm leading-relaxed mb-6">
                            The page encountered an error. Try refreshing the page.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            data-testid="error-reload-button"
                            className="border border-amber text-amber px-5 py-2 font-mono text-xs uppercase tracking-[0.25em] hover:bg-amber hover:text-ink transition-colors"
                        >
                            Reload
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
